import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../components/Spinner";
import popupImage from "../images/popup.png";
import userIcon from "../images/user.png";
import ProgressBar from "./ProgressBar";
import "./UploadPhoto.css";
import { trackProfilePicture } from "./xpUtils";

function UploadPhoto() {
  const location = useLocation();    
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(
    location.state?.photo || null
  );
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Maybe Later");
  const [userId, setUserId] = useState(null);
  const currentStep = 3;
  const inputs = location.state || {};

  // Fetch user ID when component mounts
  useEffect(() => {
    const fetchUserId = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await fetch('https://dev-api.curu.com.au/api/profile', {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.ok) {
            const data = await response.json();
            setUserId(data.id);
          }
        } catch (error) {
          console.error('Error fetching user ID:', error);
        }
      }
    };
    
    fetchUserId();
  }, []);

  useEffect(() => {
    // Update button based on whether a photo is uploaded
    if (photoPreview || selectedFile) {
      setButtonText("Next");
    } else {
      setButtonText("Maybe Later");
    }
  }, [photoPreview, selectedFile]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setPhotoPreview(null);
      setButtonText("Maybe Later");
      return;
    }
    setSelectedFile(file);
    setButtonText("Next");

    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotoPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleMaybeLaterClick = () => {
    setShowPopup(true);
  };

  const handleAgree = async () => {
    console.log("handleAgree function called");
    
    console.log("photoPreview exists:", !!photoPreview);
    console.log("selectedFile exists:", !!selectedFile);
    
    const shouldAwardXP = photoPreview !== null || selectedFile !== null;
    console.log("Should award XP?", shouldAwardXP);
    
    if (photoPreview) {
      inputs.photo = photoPreview;
    }
    
    setLoading(true);
    
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    
    try {
      const payload = new FormData();
      payload.append("email", inputs.email);
      payload.append("first_name", inputs.firstname);
      payload.append("last_name", inputs.lastname);
      payload.append("country", inputs.country.label);
      payload.append("username", inputs.username);
      
      if (selectedFile) {
        payload.append("photo", selectedFile);
      } else if (photoPreview) {
        payload.append("photo", photoPreview);
      }
      
      const response = await fetch('https://dev-api.curu.com.au/api/profile', {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: payload,
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to save data to backend');
      }
      
      // Award XP if there's a photo and we have a user ID
      if (shouldAwardXP && userId) {
        // Check if this is a first-time profile picture upload for this user
        const hasProfilePicXP = localStorage.getItem(`profilePicXPShown_${userId}`);
        
        if (!hasProfilePicXP) {
          console.log("✅ First time adding profile picture - tracking XP");
          trackProfilePicture();
          localStorage.setItem(`profilePicXPShown_${userId}`, 'true');
          
          // Dispatch event to trigger XP popup
          setTimeout(() => {
            console.log("🚀 Dispatching check-xp-earned event for profile picture");
            window.dispatchEvent(new CustomEvent('check-xp-earned'));
          }, 1000);
        } else {
          console.log("⚠️ Profile picture XP already awarded for this user");
        }
      }
      
      setLoading(false);
      setShowPopup(false);
      setShowPopup2(true);
    } catch (error) {
      setError(error.message || 'An error occurred while creating the account.');
      console.error('Error creating account:', error);
      setLoading(false); 
    }
  };

  const handleExit = () => {
    setShowPopup(false);
  };

  const handleSubmit = () => {
    setShowPopup2(true);
    window.location.href = "../skin-type";
  };

  const handleSkip = () => {
    setShowPopup2(false);
    // Navigate to profile page instead of home
    navigate("/user-profile");
  };

  const handleBackClick = () => {
    navigate("/User", { state: { ...inputs, photo: photoPreview } });
  };

  return (
    <div className="upload-login-container container">
      <div className="upload-box row justify-content-center align-items-center">
        <div className="mb-auto">
          <ProgressBar currentStep={currentStep} comboType="combo1" />

           {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <label htmlFor="upload-photo" className="file-upload-label">
            <div className="photo-container">
              <img
                src={photoPreview ? photoPreview : userIcon}
                alt="User Icon"
                className="upload-icon"
              />
              <input
                type="file"
                id="upload-photo"
                onChange={handleFileChange}
                accept="image/*"
                className="file-upload-input"
              />
            </div>
          </label>

          <p className="h5 my-4">Add a photo and we're done!</p>
        </div>

        <div className="row my-4 gx-2 justify-content-center">
          <div className="col-6">
            <button
              type="button"
              className="btn btn-light-gray w-100"
              onClick={handleBackClick}
            >
              Go Back
            </button>
          </div>
          <div className="col">
            <button
              type="button"
              className="btn btn-primary text-white w-100"
              onClick={handleMaybeLaterClick}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
      {showPopup && (
        <div className="popup">
          <button type="button" className="exit-button" onClick={handleExit}>
            X
          </button>
          <div className="popup-content">
            <img src={popupImage} alt="User" className="popup-image" />
            <h2>Just one last thing</h2>
            <p>
              By clicking "Agree", you're saying yes to{" "}
              <a
                href="https://curu.com.au/terms-conditions/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Curu's Terms and Conditions
              </a>{" "}
              It's all about keeping things safe, secure and respectful!
            </p>
            <button
              disabled={loading}
              className="popup-next-button"
              onClick={handleAgree}
            >
              {loading ? <Spinner /> : "Agree"}
            </button>
          </div>
        </div>
      )}

      {showPopup2 && (
        <div className="popup">
          <div className="popup-content">
            <img src={popupImage} alt="User" className="popup-image" />
            <h2>Would you like to take our skin quiz?</h2>
            <p>This will help us choose products which are suitable for you.</p>
            <button
              type="button"
              className="popup-next-button"
              onClick={handleSubmit}
            >
              Yes
            </button>
            <button
              type="button"
              className="popup-back-button"
              onClick={handleSkip}
            >
              Later
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UploadPhoto;